"use client";

import type { FC, Ref } from "react";
import { Columns } from "@huub-web/ui";

import type { TemplateCollection } from "../../types";
import { TemplatesParser } from "../../components";

export interface ColumnsTemplateProps {
  templates: TemplateCollection;
  // align?: ColumnsProps["align"];
}

export const ColumnsTemplate: FC<
  ColumnsTemplateProps & { ref?: Ref<HTMLDivElement> }
> = ({ templates, ref }) => (
  <Columns ref={ref} align="center">
    <TemplatesParser templates={templates} level={1} />
  </Columns>
);
